import React from 'react';

interface ContentStrategyProps {
  topics?: string[];
  targetAudience?: string;
  contentPillars?: string[];
}

export function ContentStrategy({ topics, targetAudience, contentPillars }: ContentStrategyProps) {
  const hasContent = topics?.length || targetAudience || contentPillars?.length;

  if (!hasContent) {
    return null;
  }

  return (
    <div className="py-6 border-b border-border">
      <h3 className="text-sm font-semibold text-foreground mb-4">Content Strategy</h3>

      {/* Topics */}
      {topics && topics.length > 0 && (
        <div className="mb-4">
          <div className="text-xs text-muted-foreground mb-2">Topics</div>
          <div className="flex flex-wrap gap-2">
            {topics.map((topic, index) => (
              <span
                key={index}
                className="px-3 py-1.5 bg-muted text-foreground text-sm rounded-md border border-border"
              >
                {topic}
              </span>
            ))}
          </div>
        </div>
      )}

      {/* Target Audience */}
      {targetAudience && (
        <div className="mb-4">
          <div className="text-xs text-muted-foreground mb-2">Target Audience</div>
          <p className="text-sm text-foreground bg-muted/50 px-3 py-2 rounded-md">
            {targetAudience}
          </p>
        </div>
      )}

      {/* Content Pillars */}
      {contentPillars && contentPillars.length > 0 && (
        <div>
          <div className="text-xs text-muted-foreground mb-2">Content Pillars</div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
            {contentPillars.map((pillar, index) => (
              <div
                key={index}
                className="px-3 py-2 bg-accent/10 text-foreground text-sm rounded-md border border-accent/20 flex items-center gap-2"
              >
                <span className="text-accent">▸</span>
                <span>{pillar}</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
